import React from "react";
import { Link } from "react-router-dom";
import "./NavbarElement.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class BranchSettingsNavbarElement extends React.Component<
  {
    icon: any;
    title: string;
    selected: boolean;
    onClick: any;
    linkTo: string;
    notifications?: number;
  },
  {}
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Link
        to={this.props.linkTo}
        className={
          this.props.selected
            ? "navbar-element navbar-element-selected"
            : "navbar-element"
        }
        onClick={this.props.onClick}
      >
        <div className="navbar-icon-container">
          <FontAwesomeIcon icon={this.props.icon} size="lg" />
          {!!this.props.notifications && (
            <div className="navbar-bell-new-notification">{this.props.notifications}</div>
          )}
        </div>
        <div>
          <span>{this.props.title}</span>
        </div>
      </Link>
    );
  }
}
